import { hasWindow } from "@utils/general";

import BreakpointService from "@services/breakpoint.service";

import * as HeaderModule from "@redux/modules/value/header/header.module";
import { getHeader } from "@redux/modules/value/header/header.selectors";
import * as ProfileSidebarModule from "@redux/modules/value/profileSidebar/profileSidebar.module";
import * as WishlistSidebarModule from "@redux/modules/value/wishlistSidebar/wishlistSidebar.module";
import { TStore } from "@redux/store.types";

import {
    PureAemComponent,
    registerComponent,
} from "@components/pureAemComponent";

import "./navigation.scss";

class Navigation extends PureAemComponent {
    previousWidth: number;
    dispatch: TStore["dispatch"];

    constructor(element: HTMLElement) {
        super(element);

        this.previousWidth = window.innerWidth;

        this.dispatch = window.storeManager.dispatch;

        this.init();
    }

    init() {
        window.addEventListener("resize", this.onResize.bind(this));

        this.onResize();
    }

    onResize() {
        if (this.isMobile()) {
            this.dispatch(
                HeaderModule.update({ mobile: true, flyoutActive: false }),
            );

            if (this.isResizeHorizontal()) {
                this.dispatch(WishlistSidebarModule.update({ visible: false }));
            }
        } else {
            this.dispatch(
                HeaderModule.update({ mobile: false, sidebarActive: false }),
            );
            this.dispatch(ProfileSidebarModule.update({ active: false }));
            this.dispatch(WishlistSidebarModule.update({ visible: true }));
        }

        this.updateResizeDimensions();
    }

    updateResizeDimensions() {
        this.previousWidth = window.innerWidth;
    }

    isResizeVertical() {
        return this.previousWidth === window.innerWidth;
    }

    isResizeHorizontal() {
        return !this.isResizeVertical();
    }

    isMobile() {
        return !BreakpointService.matchesMinLg();
    }
}

const InitNavigation = () => {
    hasWindow() && registerComponent("header.navigation", Navigation);
};

export { InitNavigation };
